import { api } from "../../App";
import { createNotification } from "../../components/Notifications/Notifications";
import { SET_STUDENTS_DATA_MAIN, SET_STUDENTS_LOADING } from "../types";
import { getStudents } from "./list";



export const getStudentMain = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const { data } = await api.get(`/student/${id}`)
    dispatch({ type: SET_STUDENTS_DATA_MAIN, payload: data })
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

export const updateStudentMain = (id, data) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const responce = await api.put(`/student/${id}`, data)
    createNotification('success', responce.data.message)
    dispatch(getStudents())
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

export const createStudentMain = (data) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    await api.post('/staff_roster', data)
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

export const deleteStudentMain = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    await api.delete(`/student/${id}`)
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};